<template>
  <!-- モーダルウィンドウ -->
  <div class="c-modal c-modal--team">
    <div class="c-modal__bg"></div>
    <div class="c-modal__content">
      <div class="c-modal__close" @click="onCancelClick">
        <div class="c-icon c-icon--white u-wh14">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use xlink:href="/assets/img/sprite.svg#close" />
          </svg>
        </div>
      </div>
      <div class="c-modal__inner">
        <div class="c-modal__title">{{ title }}</div>
        <div class="c-modal__data">{{ body }}</div>
        <div class="c-modal__btns">
          <button
            class="c-btn c-btn--modal c-btn--gray u-w140 u-h34 u-fs14"
            type="button"
            name="cancel"
            value="cancel"
            @click="onCancelClick"
          >
            <p class="c-btn__text">{{ cancelButton }}</p>
          </button>
          <button
            class="c-btn c-btn--modal c-btn--blue u-w140 u-h34 u-fs14"
            type="button"
            name="delete"
            value="delete"
            @click="onOkClick"
          >
            <p class="c-btn__text">{{ okButton }}</p>
          </button>
        </div>
      </div>
    </div>
  </div>
<!-- /モーダルウィンドウ -->
</template>

<script>
export default {
  props: {
    title: String,
    body: String,
    cancelButton: String,
    okButton: String,
  },
  emits: ["cancel-click","ok-click"],
  methods: {
    showConfirmModal: function() {
      $('.c-modal').addClass('is-active');
    },
    onCancelClick: function() {
      $('.c-modal').removeClass('is-active');
      this.$emit('cancel-click');
    },
    onOkClick: function() {
      $('.c-modal').removeClass('is-active');
      this.$emit('ok-click');
    }
  }
};
</script>
